import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { INotification } from '@/shared/model/notification.model';

const baseApiUrl = 'api/notifications';

export default class NotificationService {
  public find(id: string): Promise<INotification> {
    return new Promise<INotification>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public findByUserId(id: string): Promise<INotification[]> {
    return new Promise<INotification[]>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/user/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: INotification): Promise<INotification> {
    return new Promise<INotification>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: INotification): Promise<INotification> {
    return new Promise<INotification>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public partialUpdate(entity: INotification): Promise<INotification> {
    return new Promise<INotification>((resolve, reject) => {
      axios
        .patch(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public updateList(entity: INotification[]): Promise<INotification[]> {
    return new Promise<INotification[]>((resolve, reject) => {
      axios
        .patch(`${baseApiUrl}/update-list`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public findAllUnreadByUserId(userId: string): Promise<INotification[]> {
    return new Promise<INotification[]>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/unread/${userId}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public read(notificationIds: string[]): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/read`, notificationIds)
        .then(() => {
          resolve();
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
